<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:46:19
 * @LastEditTime: 2022-05-19 15:30:08
 * @LastEditors: yeqing
 * @Description: 企业基本信息组件
-->
<template>
  <div class="basicInfoModel">
    <a-form layout="horizontal">
      <a-form-item label="1、公司名称">
        <a-select
          show-search
          v-model="basicInfo.q511"
          :autoClearSearchValue="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="optionLoading ? undefined : null"
          @search="handleSearch"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
          style="width: 400px"
        >
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option
            v-for="(company, index) in companyList"
            :key="index"
            :value="company"
          >{{ company }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="2、成立日期">
        <a-date-picker
          style="width: 400px"
          placeholder
          :value="basicInfo.q512 ? moment(basicInfo.q512, dateFormat) : ''"
          @change="onChangeDate"
          :disabled="!isSelectDate"
        />
      </a-form-item>
      <a-form-item label="3、具有独立法人资格的中型、小型和微型企业" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q513">
          <a-radio value="没有">没有</a-radio>
          <a-radio value="有">有</a-radio>
        </a-radio-group>
        <svg-icon icon-class="right" class="right_icon"></svg-icon>
        <label class="link_text" @click="onSelfTest">企业规模类型自测</label>
      </a-form-item>
      <a-form-item label="4、是否经省（直辖市）级主管部门认定为省级专精特新中小企业或专精特新小巨人企业" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q514">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="5、是否已列为工业和信息化信部制造业单项冠军企业或产品的企业" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q515">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="6、是否符合城市战略定位和产业发展政策" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q516">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="7、主要产品(服务)所属领域">
        <a-cascader
          :options="optionList"
          placeholder
          @change="onChangeSelect"
          style="width: 300px"
          v-model="optionValue"
        />
      </a-form-item>
      <a-form-item label="8、企业近三年是否发生重大安全、重大质量事故、环境污染事故" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q518">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="9、企业是否发生偷税漏税或其他违法违规被处罚的情况" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q519">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="10、企业是否发生其他严重失信行为" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q5110">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="11、坚持专业化发展战略，长期专注并深耕于产业链某一环节或某一产品，能为大企业、大项目提供关键零部件、元器件和配套产品，或直接面向市场并具有竞争优势的自有品牌产品"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q5111">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="12、具有持续创新能力和研发投入，在研发设计、生产制造、市场营销、内部管理等方面不断创新并取得比较显著的效益，具有一定的示范推广价值"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q5112">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="13、重视并实施长期发展战略，公司治理规范、信誉良好、社会责任感强，生产技术、工艺及产品质量性能国内领先，注重绿色发展，加强人才队伍建设，有较好的品牌影响力，具备发展成为相关领域国际知名企业的潜力"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q5113">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div style="text-align: center; margin-top: 40px;">
        <a-button class="primary-btn pre-btn" @click="handlePre">上一步</a-button>
        <a-button @click="handleNext" class="primary-btn">下一步</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { getCompanyInfo, getCorpInfo } from "@/api/enterpriseHighNew"
import { getReportName } from "@/api/enterpriseSpecial";
import { zjtxOptionData } from "@/utils/josnData"
import moment from 'moment'
export default {
  name: "basicInfoModel",
  data() {
    return {
      isSelectDate: true,
      dateFormat: 'YYYY-MM-DD',
      companyList: [],
      optionLoading: false,
      basicInfo: {
        q511: "",
        q512: "",
        q513: "",
        q514: "",
        q515: "",
        q516: "",
        q517: "",
        q518: "",
        q519: "",
        q5110: "",
        q5111: "",
        q5112: "",
        q5113: "",
      },
      optionList: [],
      optionData: zjtxOptionData,
      q511: '', //公司名称暂存
      optionValue:[]
    };
  },
  created() {
    // 处理 optionList
    let arr = [];
    this.optionData.map((item, key) => {
      arr.push({
        label: item.label,
        value: item.label,
        children: [],
      });
      item.children.map((item1) => {
        arr[key].children.push({
          label: item1,
          value: item1,
        });
      });
    });
    this.optionList = arr;
    this.getRecordList();
        // 取缓存信息
    if(sessionStorage.getItem('basicInfo')){
      this.basicInfo = JSON.parse(sessionStorage.getItem('basicInfo'))
      if(this.basicInfo.q517){
        this.optionValue = this.basicInfo.q517.split('/')
      }
      sessionStorage.removeItem('basicInfo')
    }
  },
  methods: {
    moment,
    // 自测
    onSelfTest() {
      // 保存当前所填的信息
      sessionStorage.setItem("basicInfo",JSON.stringify(this.basicInfo))
      this.$router.push('/enterpriseScale?source=zjtx')
    },
      // 获取测评记录
    getRecordList() {
      let clientType =
        sessionStorage.getItem("page") == "gov"
          ? 1
          : sessionStorage.getItem("page") == "ICompany"
          ? 3
          : 2;
      getReportName({
        rankType: 5,
        clientType,
      }).then((res) => {
        if (res.data.length > 6) {
          this.companyList = res.data.slice(0, 6);
        } else {
          this.companyList = res.data;
        }
      });
    },
    handleFocus() {
      this.basicInfo.q511 = ''
      this.basicInfo.q512 = ''
      this.isSelectDate = true
    },
    handleBlur() {
      if (!this.basicInfo.q511) {
        this.basicInfo.q511 = this.q511
      }
    },
    onChangeSelect(e) {
      this.basicInfo.q517 = e.join("/");
    },
    handleChange(value) {
      Object.assign(this, {
        companyList: [],
        optionLoading: false,
      });
      getCorpInfo({
        companyName: value
      }).then(res => {
        if (res.data.name) {
          this.basicInfo.q512 = res.data.foundedTime
          this.isSelectDate = false
        } else {
          this.isSelectDate = true
        }
      })
    },
    handleSearch(value) {
      this.optionLoading = true;
      if (value) {
        this.q511 = value
      }
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyList = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    },

    onChangeDate(date, dateString) {
      this.basicInfo.q512 = dateString
    },

    // 上一步
    handlePre() {
      this.$router.push("/enterpriseSpecial")
    },

    // 下一步
    handleNext(e) {
      e.preventDefault();
      this.basicInfo.q512 = this.basicInfo.q512 ? this.basicInfo.q512 : '';
      this.$emit("changeTabKey", {
        name: "basicInfo",
        key: 2,
        data: this.basicInfo,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.basicInfoModel {
  margin-top: 30px;
  ::v-deep .ant-form-item {
    margin-bottom: 6px;
  }
  ::v-deep .ant-form-item-label > label {
    color: #333333;
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
  }
  ::v-deep .ant-radio-wrapper {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .right_icon {
    width: 12px;
    height: 10px;
    margin-right: 8px;
    margin-bottom: 2px;
  }
  .link_text {
    height: 14px;
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #0072f7;
    line-height: 14px;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #59a4ff;
    }
  }
  .unit {
    width: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin: 0 6px 0 10px;
  }
  .primary-btn {
    width: 133px;
    height: 40px;
    border-radius: unset;
    background: #0072f7;
    border-radius: 2px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 16px;
    border: none;
    &:hover {
      color: #fff;
      background-color: #40a9ff;
      border-color: #40a9ff;
    }
  }
  .pre-btn {
    background: #fff;
    color: #999;
    margin-right: 20px;
    border: 1px solid #eeeeee;
    &:hover {
      background-color: #fff;
      color: #40a9ff;
      border-color: #40a9ff;
    }
  }

  ::v-deep.ant-select-selection {
    border-radius: 2px;
  }
}
</style>